import React, {
  useMemo,
  useEffect,
} from 'react';
import {
  Route,
  Switch,
  Redirect,
  useLocation,
  matchPath,
} from 'react-router-dom';

import {
  SignUpWithPurchase,
} from 'web-auth-containers';

import publicRoutes from './publicRoutes';
import privateRoutes from './privateRoutes';
import PrivateLayout from './PrivateLayout';

const Routes: React.FC = () => {
  const location = useLocation();

  // preload containers
  useEffect(() => {
    [
      ...publicRoutes,
      ...privateRoutes,
    ].forEach(
      route => {
        const matched = matchPath(location.pathname + location.hash, route.path);
        if (!matched && route.preload) {
          try {
            route.component.preload();
          } catch (e) {
            console.log('e', e);
            // Not a big deal. Probably trying to fetch
            // an old version of the chunk.
          }
        }
      },
    );
  }, []);

  const routes = useMemo(() => ([
    ...publicRoutes.map(route => (
      <Route
        key={route.path}
        path={route.path}
        exact={route.exact}
        render={(props) => (route.redirect
          ? (
            <Redirect to={route.redirect} />
          ) : React.createElement(
            route.component!,
            {
              ...props,
              ...route.options,
            } as React.Attributes,
          )
        )}
      />
    )),

    ...privateRoutes.map(route => (
      <Route
        key={route.path}
        path={route.path}
        exact={route.exact}
        render={(props) => (route.redirect
          ? (
            <Redirect to={route.redirect} />
          ) : React.createElement(
            PrivateLayout,
            {
              ...route,
              routeProps: props,
            } as React.Attributes,
          )
        )}
      />
    )),
  ]), []);

  return (
    <Switch>
      {routes}

      <Route
        path="/:slug"
        render={(props) => (
          <SignUpWithPurchase
            {...props}
            requestWithSlug
          />
        )}
      />
    </Switch>
  );
};

export default Routes;
